// Environment detection utility

const PROD_API     = 'https://api.errandserver.fagierrands.com/api';
const PROD_SERVER  = 'https://api.errandserver.fagierrands.com';
const DEV_API      = 'http://localhost:8000/api';
const DEV_SERVER   = 'http://localhost:8000';

/**
 * Determines if the application is running in a local development environment.
 */
export const isLocalEnvironment = () =>
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

/**
 * Gets the appropriate API base URL (with /api suffix) based on the current environment.
 */
export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
  return isLocalEnvironment() ? DEV_API : PROD_API;
};

/**
 * Gets fallback API URLs in case the primary server is down.
 */
export const getFallbackApiUrls = () => [PROD_API];

/**
 * Gets the API base URL without the /api suffix.
 */
export const getApiServerUrl = () => {
  const base = getApiBaseUrl();
  // Strip trailing /api so callers get a clean server root
  return base.replace(/\/api\/?$/, '');
};

/**
 * Gets the frontend URL based on the current environment.
 */
export const getFrontendUrl = () => {
  if (process.env.REACT_APP_FRONTEND_URL) return process.env.REACT_APP_FRONTEND_URL;
  return isLocalEnvironment() ? 'http://localhost:3000' : 'https://fagierrands.com';
};

/**
 * Properly joins URL parts, ensuring no double slashes.
 */
export const joinUrl = (base, path) => {
  const cleanBase = base.replace(/\/+$/, '');
  const cleanPath = path.replace(/^\/+/, '');
  return `${cleanBase}/${cleanPath}`;
};

export default {
  isLocalEnvironment,
  getApiBaseUrl,
  getApiServerUrl,
  getFrontendUrl,
  joinUrl,
};
